<template>
<div class="content">
    <div class="container-fluid">
    <div class="row">
        <div class="col-md-12">
        <request-leave>
        </request-leave> 
        </div>
    </div>  
    </div>
</div>
</template>
<script>
/* eslint-disable */
import requestLeave from './todo-request-leave'
export default {
    components: {
        requestLeave
    }
}
</script>
<style lang="scss">
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-leave-management/base-request-leave.vue